import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import lodashFindIndex from 'lodash/findIndex';

import { selectPage } from '../../RTK/utility/selectors';

const useDrawerNavigator = (props) => {
  const hideDrawerContentOnLargeScreen = useMediaQuery({
    query: '(min-width: 1400px)',
  }); // hide drawer content on large screens
  const page = useSelector(selectPage);
  const isDrawerOpen =
    lodashFindIndex(props.state.history, { type: 'drawer' }) > -1;

  useEffect(() => {
    if (hideDrawerContentOnLargeScreen) {
      props.navigation.getParent('RightDrawer').closeDrawer();
    }
  }, [hideDrawerContentOnLargeScreen, props.navigation]);

  return {
    hideDrawerContentOnLargeScreen,
    isDrawerOpen,
    isStorePage: page.isStore,
  };
};

export default useDrawerNavigator;
